import { render } from "./ModuleDetails.vue?vue&type=template&id=113b9994"
import script from "./ModuleDetails.vue?vue&type=script&lang=js"
export * from "./ModuleDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__